import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onSuccessDeleteRole } from "./helpers";

const deleteRole = async ({ id }: DeleteRoleReqT) =>
  axios.delete(urlMaker(Routes.DELETE_ROLE, id));

export const useDeleteRole = () =>
  useMutation({
    mutationKey: [Keys.DELETE_ROLE_MUT],
    mutationFn: deleteRole,
    onSettled: onSuccessDeleteRole,
    cacheTime: Infinity,
  });
